import service from '@/store/services/user-email-service';

const state = {
    user: {},
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, user) => {
        state.user = user;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    emailresend({ commit, dispatch }, params) {
        return service.emailresend(params)
            .then((role) => { commit('SET_RESOURCE', role); });
    },
};

const getters = {
    user: state => state.user
};

const userEmail = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default userEmail;